import React from 'react';
import { TextField, TextFieldProps, Typography, Box, useTheme } from '@mui/material';

interface CoreInputProps extends Omit<TextFieldProps, 'label' | 'variant'> {
  label?: string;
  variant?: 'standard' | 'outlined' | 'filled' | 'underline';
  maxChars?: number;
}

const CoreInput: React.FC<CoreInputProps> = ({ label, value, variant = 'standard', maxChars, ...textFieldProps }) => {
  const theme = useTheme();
  const isUnderlineVariant = variant === 'underline';

  const isInError = maxChars && value && (value as string)?.length > maxChars;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      {
        label ? 
        <Typography
          variant="body2"
          component="label"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: 700,
            mb: 0.5,
            fontSize: '0.875rem',
          }}
        >
          {label}
        </Typography> : null
      }
      
      <TextField
        value={value || ''}
        error={!!isInError}
        helperText={isInError ? `Maximum ${maxChars} characters allowed.` : ''}
        {...textFieldProps}
        variant="standard"
        data-variant={isUnderlineVariant ? 'underline' : undefined}
        fullWidth
      />
    </Box>
  );
};

export default CoreInput;

